angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor.editForm.component', [])
    .component('editForm', {
        template: require('./edit-form.component.html'),
        bindings: {
            activityLogId: '<',
            issueId: '<',
            teamId: '<',
            creationMode: '<',
            isProjectIterationBased: '<',
            onSaved: '&',
            onCanceled: '&'
        },
        controller: require('./edit-form.controller')
    });


// WEBPACK FOOTER //
// ./components/work-log-editor/edit-form/edit-form.component.js